import Vue from 'vue'

const busEvent = new Vue()

export default busEvent
